import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconHome = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 17} height={props.height || 16} viewBox="0 0 17 16" fill="none">
      <path
        d="M2.2998 6.00004L8.2998 1.33337L14.2998 6.00004V13.3334C14.2998 13.687 14.1593 14.0261 13.9093 14.2762C13.6592 14.5262 13.3201 14.6667 12.9665 14.6667H3.63314C3.27952 14.6667 2.94038 14.5262 2.69033 14.2762C2.44028 14.0261 2.2998 13.687 2.2998 13.3334V6.00004Z"
        fill={theme.colors.text.primary}
        stroke={theme.colors.text.primary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.2998 14.6667V8H10.2998V14.6667" fill={theme.colors.background.primary} />
    </IconBase>
  )
}
